export default __webpack_public_path__ + "static/media/20160305-Colorful-Backdrop-v2.fad276fb.jpg";